module.exports = __webpack_public_path__ + "img/img_gd_adress_us@3x.a93132ba.png";